import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import UnassignedNav from './UnassignedNav';
import AdminNav from './AdminNav';
import NotificationBell from './NotificationBell';
import MentorNav from './MentorNav';
import MentorNotificationBell from './MentorNotificationBell';
import BumdesNav from './BumdesNav';
import DplNav from './DplNav';
import MahasiswaNav from './MahasiswaNav';

const Navigation = () => {
  const location = useLocation();
  const slug = location.pathname.split('/')[1];

  const { authUser, signOut } = useAuth();

  return (
    <>
      <nav className='navbar navbar-expand-lg bg-light shadow-sm'>
        <div className='container p-2'>
          {/* 🔹 Brand Logo */}
          <Link
            className='navbar-brand'
            to='/'
          >
            <img
              src='/logo192.png'
              alt='Bakrie Center Foundation'
              className='img-fluid'
              style={{ height: 50, objectFit: 'scale-down' }}
            />
          </Link>

          {/* 🔹 Mobile Toggler */}
          <button
            className='navbar-toggler'
            type='button'
            data-bs-toggle='collapse'
            data-bs-target='#navbarNav'
            aria-controls='navbarNav'
            aria-expanded='false'
            aria-label='Toggle navigation'
          >
            <span className='navbar-toggler-icon'></span>
          </button>

          {/* 🔹 Navbar Items */}
          <div
            className='collapse navbar-collapse'
            id='navbarNav'
          >
            <ul className='navbar-nav me-auto mb-2 mb-lg-0'>
              <li className='nav-item'>
                <Link
                  to='/articles'
                  className={`nav-link ${slug === 'articles' ? 'active' : ''}`}
                >
                  Publikasi
                </Link>
              </li>
              <li className='nav-item'>
                <Link
                  to='/program'
                  className={`nav-link ${slug === 'program' ? 'active' : ''}`}
                >
                  Program
                </Link>
              </li>
            </ul>

            {/* 🔹 Right Section (Auth) */}
            {!authUser ? (
              <div className='text-end'>
                <Link
                  to='/app/login'
                  className='btn btn-primary'
                >
                  Sign in
                </Link>
              </div>
            ) : (
              <>
                {/* 🔸 Unassigned (No Program) */}
                {!authUser?.activeSession && (
                  <UnassignedNav
                    authUser={authUser}
                    signOut={signOut}
                  />
                )}

                {/* 🔸 Admin */}
                {authUser?.activeSession?.roleCode === 'ADMIN' && (
                  <div className='d-flex align-items-center'>
                    <AdminNav
                      authUser={authUser}
                      signOut={signOut}
                    />
                    <div className='vr mx-3'></div>
                    <NotificationBell />
                  </div>
                )}

                {/* 🔸 Mentor */}
                {authUser?.activeSession?.roleCode === 'MENTOR' && (
                  <div className='d-flex align-items-center'>
                    <MentorNav
                      authUser={authUser}
                      signOut={signOut}
                    />
                    <div className='vr mx-3'></div>
                    <MentorNotificationBell />
                  </div>
                )}

                {/* 🔸 BUMDes */}
                {authUser?.activeSession?.roleCode
                  ?.toLowerCase()
                  ?.includes('bumdes') && (
                  <BumdesNav
                    authUser={authUser}
                    signOut={signOut}
                  />
                )}

                {/* 🔸 DPL */}
                {authUser?.activeSession?.roleCode === 'DPL' && (
                  <DplNav
                    authUser={authUser}
                    signOut={signOut}
                  />
                )}

                {/* 🔸 Mahasiswa */}
                {authUser?.activeSession?.roleCode === 'STUDENT' && (
                  <MahasiswaNav />
                )}
              </>
            )}
          </div>
        </div>
      </nav>

      {/* 🔹 Info Box */}
      <div
        className='alert alert-light text-center'
        role='alert'
      >
        <h4 className='alert-heading'>Mulai Perjalananmu Bersama BCF</h4>
        Temukan program pengembangan kepemimpinan, magang, dan kolaborasi sosial
        yang sesuai dengan perjalananmu.
      </div>
      <style>{`
        .hover-scale { transition: transform 0.2s; }
        .hover-scale:hover { transform: scale(1.03); }
        .transition-all { transition: all 0.2s ease-in-out; }
        .hover-bg-light:hover { background-color: #f8fafc; }
        .leading-tight { line-height: 1.25; }
        .truncate-2-lines {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .dropdown-scroll::-webkit-scrollbar {
          width: 4px;
        }
        .dropdown-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .dropdown-scroll::-webkit-scrollbar-thumb {
          background: #e2e8f0;
          border-radius: 10px;
        }
      `}</style>
    </>
  );
};

export default Navigation;
